import { createFileRoute } from '@tanstack/react-router';
import type { JSX } from 'react';

import { ReviewConversionPage } from '@/areas/flexible-calculations/FlexibleCalculationTemplates/ReviewConversion';
import { canViewFlexibleCalculationTemplates } from '@/shared/permissions/pagePermissions';
import type { PageStaticData } from '@/shared/routing';
import { SidebarPageContent } from '@/shared/ui/PageLayoutCollapsibleSidebar';

export const Route = createFileRoute(
    '/_authenticated/next/templates/flexible-calculation/review-conversion/$legacyTemplateId/$flexibleCalculationTemplateId',
)({
    staticData: {
        access: { permissions: canViewFlexibleCalculationTemplates },
        chrome: 'none',
    } satisfies PageStaticData,
    component: RouteComponent,
});

function RouteComponent(): JSX.Element {
    const pathParams = Route.useParams();
    return (
        <SidebarPageContent layoutVariant="fullWidth">
            <ReviewConversionPage
                legacyTemplateId={pathParams.legacyTemplateId}
                flexibleCalculationTemplateId={pathParams.flexibleCalculationTemplateId}
            />
        </SidebarPageContent>
    );
}
